import { ITextResources } from './MikeNotificationChip';

const mikeChipTextResources: ITextResources = {
  error: 'Error',
  news: 'News',
  maintenance: 'Maintenance',
  warning: 'Warning',
};

export default mikeChipTextResources;
